import { BuildType } from '@/services/ApiService.ts';
import { ChatRequest, ChatResponse, ConversationFeedbackResponse, ConversationHistoryResponse, ConversationListResponse, FeedbackResponse, SubmitFeedbackRequest, UpdateFeedbackRequest } from '@/apiTypes/AiTypes.ts';
import { encodeB64 } from '@/utils/base64';

export const aiApiEndpoints = (build: BuildType) => ({
    aiChat: build.mutation<ChatResponse, ChatRequest>({
        query: ({ message, context, ...rest }) => ({
            url: 'ai/chat',
            method: 'POST',
            body: {
                message: encodeB64(JSON.stringify(message)),
                ...(context && { context: encodeB64(JSON.stringify(context)) }),
                ...rest,
            },
        }),
    }),
    submitAiFeedback: build.mutation<FeedbackResponse, SubmitFeedbackRequest>({
        query: request => ({
            url: 'ai/feedback',
            method: 'POST',
            body: request,
        }),
        invalidatesTags: ['AiFeedback'],
    }),
    updateAiFeedback: build.mutation<FeedbackResponse, UpdateFeedbackRequest>({
        query: ({ feedbackId, ...body }) => ({
            url: `ai/feedback/${feedbackId}`,
            method: 'PUT',
            body,
        }),
        invalidatesTags: ['AiFeedback'],
    }),
    getConversations: build.query<ConversationListResponse, void>({
        query: () => 'ai/conversations',
        providesTags: ['AiConversations'],
    }),
    getConversationHistory: build.query<ConversationHistoryResponse, string>({
        query: conversationId => `ai/conversations/${conversationId}`,
        providesTags: ['AiConversations'],
    }),
    getConversationFeedback: build.query<ConversationFeedbackResponse, string>({
        query: conversationId => `ai/conversations/${conversationId}/feedback`,
        providesTags: ['AiFeedback'],
    }),
});
